// openInNewTab opens a Stripe page whose URL the server makes on request (the
// billing portal, her Express Dashboard) in a new tab. The tab is opened
// before asking for the URL, inside the tap, so Safari doesn't block it as a
// pop-up; without a tab (blocked anyway) it opens here instead. A failure
// closes the empty tab and is thrown for the caller to show.
export async function openInNewTab(url: () => Promise<string>): Promise<void> {
  const tab = window.open('', '_blank')
  try {
    const to = await url()
    if (tab) tab.location.href = to
    else window.location.assign(to)
  } catch (error) {
    tab?.close()
    throw error
  }
}
